import { EMAIL_REGEX } from '@asgard/utils';
import { z } from 'zod';

export const MagnetOnboardingFormSchema = z
  .object({
    reason: z.string(),
    fullName: z
      .string()
      .nonempty('common:required-message')
      .min(2, 'common:form.min-length-2'),
    email: z
      .string()
      .nonempty('common:required-message')
      .min(2, 'common:form.min-length-2'),
    company: z
      .string()
      .nonempty('common:required-message')
      .min(2, 'common:form.min-length-2')
  })
  .refine((schema) => schema.email?.match(EMAIL_REGEX), {
    path: ['email'],
    message: `common:form.invalid-email`
  });

export type MagnetOnboardingForm = z.infer<typeof MagnetOnboardingFormSchema>;
